import { render } from "./KSTour.vue?vue&type=template&id=4341f078&scoped=true"
import script from "./KSTour.vue?vue&type=script&lang=js"
export * from "./KSTour.vue?vue&type=script&lang=js"

import "./KSTour.vue?vue&type=style&index=0&id=4341f078&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4341f078"]])

export default __exports__